import React, { Component } from 'react';
import L from 'leaflet';
import { State} from './model'


interface LeafletMapProps {
    onMapMoveStart: (center: L.LatLng) => void;
    onMapMove: (center: L.LatLng) => void;
    defaultLocation: { lat: number; lng: number };

}

class LeafletMap extends Component<LeafletMapProps, State> {
    private mapRef: React.RefObject<HTMLDivElement>;
    private map?: L.Map;
    private marker?: L.Marker;
    private mapInterval?: NodeJS.Timeout;

    constructor(props: LeafletMapProps) {
        super(props);
        this.mapRef = React.createRef<HTMLDivElement>();
        this.map = null;
        this.marker = null;
        this.mapInterval = null;
        this.state = this.getInitialState();
    }
    componentDidMount() {
       

        const { lat, lng } = this.props.defaultLocation;
        const centerPosition = L.latLng(lat, lng);

        const zoom = 15;
        this.map = new L.Map(this.mapRef.current!, { zoomControl: false });
        this.map.setView(centerPosition, zoom);
        L.control.zoom({
            position: 'bottomright'
        }).addTo(this.map);
        new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.map);

        const customIcon = L.icon({
            iconUrl: '/Content/public/image/location-outline.png',
            iconSize: [32, 32],
            iconAnchor: [16, 32]
        });

        this.marker = new L.Marker(centerPosition, { icon: customIcon }).addTo(this.map);

        this.map.on('movestart', () => {
            const center = this.map!.getCenter();
            this.props.onMapMoveStart(center);
        });

        this.map.on('move', () => {
            const center = this.map!.getCenter();
            this.marker!.setLatLng(center);
            this.props.onMapMove(center);
        });

        this.mapInterval = setInterval(() => {
            this.map!.invalidateSize();
        }, 1000);
    }




    componentDidUpdate(prevProps: LeafletMapProps) {

        

        // Check if the defaultLocation prop has changed
        if (
            prevProps.defaultLocation.lat !== this.props.defaultLocation.lat ||
            prevProps.defaultLocation.lng !== this.props.defaultLocation.lng
        ) {
            // Update the map view with the new defaultLocation
            this.setDefaultLocation(this.props.defaultLocation.lat, this.props.defaultLocation.lng);
        }
    }
    setDefaultLocation(lat, lng) {
        const centerPosition = L.latLng(lat, lng);
        this.map.setView(centerPosition, 15);
    }

    setTestMapTo(lat: number = 40.737, lng: number = -73.923) {
        this.map.panTo(new L.LatLng(lat, lng));
    }

    private getInitialState = () => ({
        lat: null,
        lng: null,
    })

    getMapLatLng() {
        if (this.map) {
            const center = this.map.getCenter();
            return { lat: center.lat, lng: center.lng };
        }
        return null;
    }

    componentWillUnmount() {
        if (this.mapInterval) {
            clearInterval(this.mapInterval);
        }
    }

    render() {
        return (
           <>
            <div id="map" ref={this.mapRef} style={{ height: '460px', width: '100%' }}></div>
           </>
        );
    }
}
export default LeafletMap;
